import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useCallback, useState } from 'react';
import { Skeleton } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine, LabelList, Cell, Legend, } from 'recharts';
import { useTypedTheme } from '@monorepo-web/styles';
import { useIsMobile } from '@monorepo-web/utils';
import { CustomLabelFunction, useFormatFunction, renderLegendFunction, } from '../componentsFunctions';
export const GraficoBarra = ({ data, height, onClickHandle, colors, hideXAxisLabels, isPercentToggle, dispatchPDF = false, handleOnAnimationEnd, moneyPrefix, isBarHorizontal, showAnimation, }) => {
    const theme = useTypedTheme();
    const isMobile = useIsMobile();
    const [isAnimation, setIsAnimation] = useState(true);
    const useFormat = (value) => useFormatFunction(value, isPercentToggle, moneyPrefix);
    const renderLegend = (value) => renderLegendFunction(value, isPercentToggle, moneyPrefix);
    const handleClick = useCallback((entry) => {
        if (onClickHandle)
            onClickHandle(entry);
    }, []);
    const listaBarra = data === null || data === void 0 ? void 0 : data.map((obj) => {
        return obj.value;
    });
    const CustomLabel = ({ x, y, value, width, height, listaValores, }) => {
        return CustomLabelFunction(moneyPrefix, x, y, value, width, height, isPercentToggle, true, dispatchPDF, isMobile, listaValores, isBarHorizontal);
    };
    const handleAnimationEnd = () => {
        () => setIsAnimation(false);
        if (handleOnAnimationEnd)
            handleOnAnimationEnd();
    };
    let maxDataValue = 0;
    let minDataValue = 0;
    let tickIntervalBarChart = 0;
    if (data) {
        maxDataValue = Math.max(...data.map((o) => o.value));
        minDataValue = Math.min(...data.map((o) => (o.value <= 0 ? o.value : 0)));
        tickIntervalBarChart = Math.floor(maxDataValue / 4);
    }
    const xAxisConfig = isBarHorizontal
        ? {
            type: 'number',
            axisLine: false,
            domain: [minDataValue, maxDataValue * 1.1],
            tickFormatter: useFormat,
            ticks: Array.from({ length: Math.floor((maxDataValue * 1.1) / tickIntervalBarChart) + 1 }, (_, i) => i * tickIntervalBarChart),
        }
        : {
            tickLine: false,
            axisLine: false,
            dataKey: 'name',
            tick: hideXAxisLabels ? false : true,
            angle: 45,
            dx: 15,
            dy: 20,
            minTickGap: -200,
        };
    const yAxisConfig = isBarHorizontal
        ? {
            type: 'category',
            dataKey: 'name',
            tick: { dx: dispatchPDF ? -15 : '' },
        }
        : {
            tickLine: false,
            axisLine: false,
            tick: { width: 80 },
            padding: { bottom: 24 },
            domain: data ? ['auto', Math.max(...data.map((o) => o.value)) * 1.1] : [],
            tickFormatter: useFormat,
        };
    const cartesianGridConfig = isBarHorizontal
        ? {
            horizontal: false,
            strokeDasharray: '5 2',
        }
        : {
            vertical: false,
            strokeDasharray: '1 0',
        };
    return data && data.length > 0 ? (_jsx("div", Object.assign({ style: { marginTop: 50 } }, { children: _jsx(ResponsiveContainer, Object.assign({ width: "100%", height: height }, { children: _jsxs(BarChart, Object.assign({ width: 500, height: 300, data: data, margin: {
                    top: isBarHorizontal ? 0 : 16,
                    right: isBarHorizontal ? 40 : 32,
                    left: isBarHorizontal ? 70 : 24,
                    bottom: 32,
                }, layout: isBarHorizontal ? 'vertical' : 'horizontal', onClick: (data) => {
                    if (data && data.activeLabel && data.activePayload && data.activePayload.length > 0) {
                        handleClick(isBarHorizontal ? data.activeLabel : data.activePayload[0]);
                    }
                } }, { children: [_jsx(CartesianGrid, Object.assign({}, cartesianGridConfig)), _jsx(XAxis, Object.assign({}, xAxisConfig)), hideXAxisLabels ? (_jsx(Legend, { payload: data.map((item, index) => ({
                            id: item.name,
                            type: 'square',
                            value: item.value,
                            color: theme.chartColors[index % theme.chartColors.length],
                        })), content: renderLegend, verticalAlign: "bottom", style: { height: '300px !important' } })) : null, _jsx(YAxis, Object.assign({}, yAxisConfig)), _jsx(Tooltip, { wrapperStyle: { outline: 'none' }, formatter: (value) => [useFormat(value), 'Valor'] }), _jsx(ReferenceLine, { y: 0, stroke: theme.fontColor }), _jsxs(Bar, Object.assign({ dataKey: "value", onAnimationEnd: handleAnimationEnd, isAnimationActive: showAnimation ? isAnimation : false }, { children: [data.map((entry, index) => (_jsx(Cell, { cursor: "pointer", fill: typeof colors !== 'string' ? colors[index % colors.length] : colors }, `cell-${index}`))), _jsx(LabelList, { dataKey: "value", position: "top", content: _jsx(CustomLabel, { listaValores: listaBarra }) })] }))] })) })) }))) : (_jsx(Skeleton, { variant: "rectangular", height: height, width: "100%" }));
};
